<script setup lang="ts">
import { getCategoryRoute, getTranslatedProperty } from '@shopware/helpers';

const { navigationElements } = useNavigation({
  type: 'footer-navigation',
});

const isGoogleInspect = useState('isGoogleInspect', () => false)

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const { y } = useWindowScroll({ behavior: 'smooth' });

function scrollToTop() {
  y.value = 0;
}

</script>

<template>
  <footer class="bg-[#f7ebdd] text-[#704530] mt-10">
    <div class="container">
      <menu class="flex flex-col items-center pt-8">
        <button class="lg:hidden" @click="scrollToTop">
          <i class="pi pi-arrow-up text-2xl" />
        </button>

        <section class="w-full lg:flex justify-between items-start gap-x-20">
          <NuxtLink to="/">
            <img
              src="~/assets/logo.png"
              alt="Kavos Bankas"
              class="max-lg:hidden md:w-full md:max-w-72"
            />
          </NuxtLink>

          <div
            class="max-lg:mt-4 flex flex-col lg:flex-row items-start gap-3 lg:gap-7"
          >
            <div>
              <h2 class="font-bold">
                {{ $t('footer.title') }}
              </h2>

              <p class="mt-1 text-sm">
                {{ $t('footer.subtitle') }}
              </p>
            </div>

            <ClientOnly>
              <SwNewsletterForm v-if="!isGoogleInspect" />
            </ClientOnly>
          </div>
        </section>

        <Divider />

        <section
          v-if="navigationElements?.length"
          class="w-full columns-[3_240px] gap-8"
        >
          <div
            v-for="navigationElement in navigationElements"
            :key="navigationElement.id"
            class="mb-4 break-inside-avoid"
          >
            <h3 class="font-semibold uppercase">
              {{ getTranslatedProperty(navigationElement, 'name') }}
            </h3>

            <ul
              v-if="navigationElement.childCount"
              class="flex flex-col h-full md:gap-2 mt-4"
            >
              <li
                v-for="navigationChild in navigationElement.children"
                :key="navigationChild.id"
                class="text-sm"
              >
                <NuxtLink
                  :target="
                    getTranslatedProperty(navigationChild, 'externalLink') ||
                    getTranslatedProperty(navigationChild, 'linkNewTab')
                      ? '_blank'
                      : ''
                  "
                  :to="
                    formatLink(getCategoryRoute(navigationChild)) ||
                    getTranslatedProperty(navigationChild, 'externalLink')
                  "
                >
                  {{ getTranslatedProperty(navigationChild, 'name') }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </section>

        <Divider />

        <div class="w-full">
          <p class="text-lg font-bold">{{ $t('footer.followUs') }}</p>

          <div class="flex gap-4 mt-3">
            <NuxtLink to="https://www.facebook.com/KavosBankas" target="_blank" aria-label="Aplankykite mūsų Facebook paskyrą"
              ><i class="pi pi-facebook"
            /></NuxtLink>
            <NuxtLink to="https://www.instagram.com/kavos_bankas/" target="_blank" aria-label="Aplankykite mūsų Instagram paskyrą"
              ><i class="pi pi-instagram"
            /></NuxtLink>
          </div>
        </div>
      </menu>

      <Divider />

      <div
        class="text-xs md:text-sm text-gray-800 pb-4 w-full gap-1 inline-flex flex-wrap items-center justify-center opacity-80"
      >
        <NuxtLink href="https://stovendo.com" target="_blank">
          <img src="/img/stovendo.svg" alt="Stovendo" class="h-4" />
        </NuxtLink>

        <div>{{ $t('footer.copyright.text') }}</div>

        <NuxtLink href="https://shopware.com" target="_blank">
          <img
            src="/img/shopware.svg"
            alt="Shopware"
            class="h-6 stroke-black"
          />
        </NuxtLink>

        <div>{{ $t('footer.copyright.companyName') }}</div>
      </div>
    </div>
  </footer>
</template>
